import Vue from 'vue'
import _ from 'lodash'
import {getWhiteboard, putWhiteboard, getOptimizationControl} from '../helper'

const whiteboardStore = {
  state: {
    moveToBottom: false,
    activeBoard: 'default',
    droppedBoard: null,
    dropOnNoteId: null,
    notes: [],
    points: null
  },
  getters: {
    getActiveBoard (state) {
      return state.notes.filter(x => x.board === state.activeBoard)
    },
    getBoardsList (state) {
      return state.notes.map(x => x.board).filter((x, i, a) => a.indexOf(x) === i)
    },
    getListByBoards (state, getters) {
      let result = {}
      for (let i in getters.getBoardsList) {
        let board = getters.getBoardsList[i]
        result[board] = state.notes.filter(x => x.board===board).map(x => x.id).reverse()
      }
      return result
    },
    normalizedPoints (state) {
      let output = {}
      let equipment_name = ''
      let sensor_name = ''
      for (let i in state.points){
        equipment_name = state.points[i].equipment_name
        sensor_name =  state.points[i].sensor_name

        let a = _.get(output, equipment_name, {})
        a[sensor_name] = state.points[i]
        output[equipment_name] = a
      }
      return output
    },
    getNormalizedBoard (state) {
      let result = {}
      for (let i in state.notes) {
        let note = state.notes[i]
        result[note.id] = note
      }
      return result
    },
    getNotesById: (state) => (id) => {
      return state.notes.filter(x => x.id === id)[0]
    },
    maxId: (state) => {
      let result = _.max(state.notes.map((x) => x.id))
      if(!result) {
        return 1
      }  else {
        return result
      }

    }
  },
  actions: {
    async addBoard (context, payload) {
      let newBoardName = payload
      context.dispatch('addToWhiteboard',
        {
          label: newBoardName,
          equipment: null,
          sensor: null,
          board: newBoardName
        })
    },
    async refreshWhiteboard (context) {
      let whiteboard = await getWhiteboard({
        facility_name: context.rootState.pointsListStore.pointsList.facility_name
      })

      context.commit('updateWhiteboard', whiteboard)
    },
    async saveWhiteboard (context) {
       await putWhiteboard(
        {
          facility_name: context.rootState.pointsListStore.pointsList.facility_name,
          board: {
            notes: context.state.notes
          }
        }
      )
    },
    async addToWhiteboard (context, payload) {
      let a = payload
      a.board = a.board ? a.board : 'default'
      a.backgroundColor = a.backgroundColor === '' ? '' : (a.backgroundColor ? a.backgroundColor : '#ffffff')
      a.top = a.top ? a.top : (Math.random() * 500)
      a.left = a.left ? a.left : (Math.random() * 500)
      a.width = a.width ? a.width : 200
      a.height = a.height ? a.height : 200
      a.id = a.id? a.id: context.getters.maxId +1
      context.commit('addStickie', a)
    },
    moveNoteToBoard (context, payload) {
      context.commit('editStickieBoard',
        {id: payload.noteId, boardId: payload.dropzoneId}
      )
    },
    moveNoteToNote (context, payload) {
      let dropOnNote = context.getters.getNotesById(payload.dropOnNoteId)
      let note = context.getters.getNotesById(payload.noteId)
      // copy styling across
      note.left = dropOnNote.left
      note.top = dropOnNote.top
      note.backgroundColor = dropOnNote.backgroundColor
      note.atBackground = dropOnNote.atBackground
      note.width = dropOnNote.width
      note.height = dropOnNote.height
      context.commit('editStickie', note)
      context.commit('removeStickie', dropOnNote.id)
    },
    async refreshPoints (context) {
      let points = (await getOptimizationControl(
          {'facility_name': context.rootState.pointsListStore.pointsList.facility_name}
        ))['result']
      context.commit('commitPoints', points)
    }
  },
  mutations: {
    commitPoints (state, payload) {
      state.points = payload
    },
    applyNotes (state, payload) {
      state.notes = payload
    },
    updateActiveBoard (state, payload) {
      state.activeBoard = payload
    },
    updateDroppedBoard (state, payload) {
      state.droppedBoard = payload
    },
    updateDropOnNoteId (state, payload) {
      state.dropOnNoteId = payload
    },
    toggleMoveToBottom (state, payload) {
      if (!payload) {
        state.moveToBottom = !state.moveToBottom
      } else {
        state.moveToBottom = payload.flag
      }
    },
    clearWhiteboard (state, payload) {
      Vue.set(state, 'notes', [])
    },
    updateWhiteboard (state, payload) {
      state.notes = payload.board.notes
      for (let i in state.notes) {
        if (!state.notes[i].board) {
          state.notes[i].board = 'default'
        }
      }
    },
    removeStickie (state, id) {
      implRemoveStickie(state, id)
    },
    addStickie (state, payload) {
      implAddStickie(state, payload)
    },
    editStickieBoard (state, payload) {
      let note = implRemoveStickie(state, payload.id)[0]
      if (!note) return
      note.board = payload.boardId
      implAddStickie(state, note)
    },
    replaceBoard (state, payload) {
      state.notes = payload
    },
    editStickie (state, payload) {
      implRemoveStickie(state, payload.id)
      implAddStickie(state, payload)

    }
  }
}

function implRemoveStickie (state, id) {
  for (let i in state.notes) {
    if (state.notes[i].id == id) {
      return state.notes.splice(i, 1)
    }
  }
}

function implAddStickie (state, payload) {
  let note = payload
  if (state.moveToBottom) {
    state.notes.unshift(note)
  } else {
    state.notes.push(note)
  }

}

function myhash (item) {
  let hash = require('object-hash')
  return hash([item, Math.random()])
}

export default whiteboardStore
